import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/Layout";
import { PageHeader, Breadcrumbs } from "@/components/Bits";
import { Check, UtensilsCrossed, Sparkles, HardHat, Truck, Coffee, ShoppingBag } from "lucide-react";

const FREE = ["Acceso a lecciones iniciales", "3 actividades personalizadas al día", "Progreso básico", "Todas las herramientas gratuitas", "Publicidad solo en guías editoriales públicas"];
const PREMIUM = ["Sin anuncios", "Acceso a todos los cursos", "Conversaciones con IA", "Ejercicios personalizados", "Repasos inteligentes", "Estadísticas avanzadas", "Descargas", "Certificado interno de finalización (no oficial)"];
const PACKS = [["Hostelería", UtensilsCrossed], ["Limpieza", Sparkles], ["Construcción", HardHat], ["Logística", Truck], ["Restauración", Coffee], ["Comercio", ShoppingBag]];

export default function Pricing() {
  return (
    <>
      <Seo title="Precios y planes" description="Plan gratuito con acceso completo a las herramientas, el curso A1 y las guías de Hallo Suiza." noindex />
      <PageHeader overline="Precios" title="Empieza gratis. Amplía cuando lo necesites."
        subtitle="Empieza hoy con el plan gratuito: herramientas de práctica y lecciones iniciales sin coste. Estamos preparando Premium y los packs profesionales." />
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-12">
        <Breadcrumbs items={[{ label: "Inicio", to: "/" }, { label: "Precios" }]} />
        <div className="grid md:grid-cols-2 gap-6">
          <div className="rounded-lg border border-border bg-card p-8">
            <h2 className="font-display font-bold text-2xl">Gratuito</h2>
            <p className="font-display font-black text-4xl mt-2">0 CHF</p>
            <ul className="mt-6 space-y-2.5 text-sm">{FREE.map((x) => <li key={x} className="flex gap-2"><Check size={16} className="text-primary shrink-0 mt-0.5" />{x}</li>)}</ul>
            <Link to="/registro"><Button className="mt-8 w-full rounded-full" data-testid="pricing-free">Empieza gratis</Button></Link>
          </div>
          <div className="rounded-lg border-2 border-primary bg-card p-8 relative">
            <span className="absolute -top-3 left-8 rounded-full bg-primary text-primary-foreground text-xs px-3 py-1 font-medium">Próximamente</span>
            <h2 className="font-display font-bold text-2xl">Premium</h2>
            <p className="text-sm text-muted-foreground mt-2">Funciones avanzadas para acelerar tu aprendizaje.</p>
            <ul className="mt-6 space-y-2.5 text-sm">{PREMIUM.map((x) => <li key={x} className="flex gap-2"><Check size={16} className="text-primary shrink-0 mt-0.5" />{x}</li>)}</ul>
            <Link to="/contacto"><Button variant="outline" className="mt-8 w-full rounded-full" data-testid="pricing-premium">Avísame cuando esté disponible</Button></Link>
          </div>
        </div>
        <div className="mt-12">
          <h2 className="font-display font-bold text-2xl mb-4">Packs profesionales</h2>
          <p className="text-sm text-muted-foreground mb-6 max-w-2xl">Vocabulario, frases y simulaciones específicas para tu sector. Próximamente.</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {PACKS.map(([name, Icon]) => (
              <div key={name} className="rounded-lg border border-border bg-card p-5 flex items-center gap-3"><Icon size={20} className="text-accent" /><span className="font-medium">{name}</span></div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
